// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionArticle_articleMain__Xiu1S","noSidePaddings":"SectionArticle_noSidePaddings__mgMyQ","aboutUsFirst":"SectionArticle_aboutUsFirst__cCzHP"};